export const ContactAttributeTypeEnum = Object.freeze({
  NUMBER: 1,
  TEXT: 2,
  DROPDOWN: 3,
  DATE_PICKER: 4
})
